// @flow
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import Box from 'sail/Box';
import Group from 'sail/Group';

import Select from 'sail/Select';
import Toggle, {ToggleItem} from 'sail/Toggle';

import {useLocation, usePrefs} from 'docs/data';

import type {IntegrationBuilderType} from './IntegrationBuilder';

const messages = defineMessages({
  checkoutLabel: {
    id: 'docsShell.integrationBuilder.guide.checkoutLabel',
    description: 'Toggle button label',
    defaultMessage: 'Prebuilt Checkout page',
  },
  paymentsLabel: {
    id: 'docsShell.integrationBuilder.guide.paymentsLabel',
    description: 'Toggle button label',
    defaultMessage: 'Custom payment flow',
  },
});

type IntegrationBuilderButtonGroupProps = {|
  type: IntegrationBuilderType,
|};

export const IntegrationBuilderButtonGroup = ({
  type,
}: IntegrationBuilderButtonGroupProps) => {
  const {pushLocation} = useLocation();
  const intl = useIntl();
  const {getPref} = usePrefs();

  if (getPref('platform') !== 'web') {
    return null;
  }

  if (!['payments', 'checkout'].includes(type)) {
    return null;
  }

  const showCheckout = type === 'checkout';
  const checkoutLabel = intl.formatMessage(messages.checkoutLabel);
  const paymentsLabel = intl.formatMessage(messages.paymentsLabel);

  const switchIntegration = (integrationType) => {
    pushLocation(`/docs/${integrationType}/quickstart`);
  };
  return (
    <Box margin={{top: 16}}>
      <Group direction="horizontal" spacing={8} className="Guide--toggle-full">
        <Toggle name="Guide--toggle" type="radio">
          <ToggleItem
            key="Guide--toggle--checkout"
            label={checkoutLabel}
            checked={showCheckout}
            onChange={() => {
              switchIntegration('checkout');
            }}
          />
          <ToggleItem
            key="Guide--toggle--elements"
            label={paymentsLabel}
            checked={!showCheckout}
            onChange={() => {
              switchIntegration('payments');
            }}
          />
        </Toggle>
      </Group>
      <Select
        className="Guide--toggle-small"
        value={showCheckout ? 'checkout' : 'payments'}
        width={200}
        onChange={(val) => {
          switchIntegration(val);
        }}
        options={[
          {
            value: 'checkout',
            label: checkoutLabel,
          },
          {
            value: 'payments',
            label: paymentsLabel,
          },
        ]}
      />
    </Box>
  );
};
